define('OutSystems/ClientRuntime/modules/Storage/StorageEnvironment',["require", "exports", "./InMemoryStorage", "./StorageNaming", "./StorageType"], function (require, exports, InMemoryStorage_1, StorageNaming_1, StorageType_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.tryExpandStorage = exports.setCustomSessionStorage = exports.setCustomPersistentStorage = exports.getSessionStorage = exports.getPersistentStorage = exports.isSpecificStorageAvailable = void 0;
    var builtInPersistentStorage = typeof window === "undefined" ? undefined : window.localStorage;
    var builtInSessionStorage = typeof window === "undefined" ? undefined : window.sessionStorage;
    var getBuiltInStorage = function (storageType) {
        return storageType === StorageType_1.default.Persistent ? builtInPersistentStorage : builtInSessionStorage;
    };
    var currentPersistentStorage = isSpecificStorageAvailable(StorageType_1.default.Persistent)
        ? getBuiltInStorage(StorageType_1.default.Persistent)
        : new InMemoryStorage_1.default();
    var currentSessionStorage = isSpecificStorageAvailable(StorageType_1.default.Session)
        ? getBuiltInStorage(StorageType_1.default.Session)
        : new InMemoryStorage_1.default();
    function isSpecificStorageAvailable(storageType) {
        var testKey = StorageNaming_1.OS_STORAGE_PREFIX + "test";
        var testValue = "1";
        try {
            var storage = getBuiltInStorage(storageType);
            storage.setItem(testKey, testValue);
            var writeOkFlag = storage.getItem(testKey) === testValue;
            storage.removeItem(testKey);
            return writeOkFlag;
        }
        catch (e) {
            return false;
        }
    }
    exports.isSpecificStorageAvailable = isSpecificStorageAvailable;
    function getPersistentStorage() {
        return currentPersistentStorage;
    }
    exports.getPersistentStorage = getPersistentStorage;
    function getSessionStorage() {
        return currentSessionStorage;
    }
    exports.getSessionStorage = getSessionStorage;
    function setCustomPersistentStorage(customStorage) {
        currentPersistentStorage = customStorage;
    }
    exports.setCustomPersistentStorage = setCustomPersistentStorage;
    function setCustomSessionStorage(customStorage) {
        currentSessionStorage = customStorage;
    }
    exports.setCustomSessionStorage = setCustomSessionStorage;
    function tryExpandStorage(storageType) {
        if (storageType === StorageType_1.default.Persistent && currentPersistentStorage !== builtInPersistentStorage) {
            console.warn("The localStorage is full... Proceding with a static Javascript object");
            currentPersistentStorage = new InMemoryStorage_1.default(currentPersistentStorage);
            return true;
        }
        else if (storageType === StorageType_1.default.Session && currentSessionStorage !== builtInSessionStorage) {
            console.warn("The sessionStorage is full... Proceding with a static Javascript object");
            currentSessionStorage = new InMemoryStorage_1.default(currentSessionStorage);
            return true;
        }
        return false;
    }
    exports.tryExpandStorage = tryExpandStorage;
});
//# sourceMappingURL=StorageEnvironment.js.map;
